import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MasterDataService } from '../../../secure/master-data/_services/master-data.service';
import * as VehicleActions from '../../actions/master-data/vehicle.actions';

@Injectable()
export class VehicleEffects {
  constructor(
    private actions$: Actions,
    private masterDataService: MasterDataService
  ) {}

  loadVehicles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.loadVehicles),
      mergeMap(() =>
        this.masterDataService.getAllVehicles().pipe(
          map((vehicles) => VehicleActions.loadVehiclesSuccess({ vehicles })),
          catchError((error) => of(VehicleActions.loadVehiclesFailure({ error: error?.error.error })))
        )
      )
    )
  );

  addVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.addVehicle),
      mergeMap(({ vehicle }) =>
        this.masterDataService.addNewVehicle(vehicle).pipe(
          mergeMap(saved => [
            VehicleActions.addVehicleSuccess({
              vehicle: saved,
              message: 'Vehicle added successfully'
            }),
            VehicleActions.loadVehicles()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while creating the vehicle';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(VehicleActions.loadVehiclesFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  updateVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.updateVehicle),
      mergeMap(({ vehicle }) =>
        this.masterDataService.updateVehicle(vehicle).pipe(
          mergeMap(saved => [
            VehicleActions.updateVehicleSuccess({
              vehicle:saved,
              message: 'Vehicle updated successfully'
            }),
            VehicleActions.loadVehicles()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while updating the vehicle';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(VehicleActions.loadVehiclesFailure({ error: errorMessage }));
          })
        )
      )
    )
  );

  deleteVehicle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VehicleActions.deleteVehicle),
      mergeMap(({ id }) =>
        this.masterDataService.deleteVehicle(id).pipe(
          mergeMap(saved => [
            VehicleActions.deleteVehicleSuccess({
              id:id,
              message: 'Vehicle deleted successfully'
            }),
            VehicleActions.loadVehicles()
          ]),
          catchError((error) => {
            let errorMessage = 'An error occurred while deleting the vehicle';
            if (error?.error?.error) {
              errorMessage = error.error.error;
            } else {
              errorMessage = error?.message || errorMessage;
            }
            return of(VehicleActions.loadVehiclesFailure({ error: errorMessage }));
          })
        )
      )
    )
  );
}